export const analyticsPluginName = {
    googleAnalytics: 'google-analytics',
    facebookPixel: 'facebook-pixel',
    googleAds: 'google-ads',
    hotjar: 'hotjar',
    clarity: 'clarity',
    helpScout: 'helpscout',
};
